import { inject, Injectable } from '@angular/core';
import { DialogService } from '@core/services/dialog.service';
import {
  ImagePreviewDialogComponent,
  FullImageDialogData,
} from './image-preview-dialog.component';

@Injectable({ providedIn: 'root' })
export class ImagePreviewDialogService {
  private dialog = inject(DialogService);

  openFullImageDialog(data: FullImageDialogData): void {
    this.dialog.open<FullImageDialogData, ImagePreviewDialogComponent>({
      hideFooter: true,
      size: 'lg',
      hideHeader: true,
      cancelText: 'General.Close',
      contentComponent: ImagePreviewDialogComponent,
      data,
    });
  }
}
